import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StudentExamsService } from '../../../services/exams/student-exams.service';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-exam-register-students',
  imports: [CommonModule],
  templateUrl: './exam-register-students.component.html',
  styleUrl: './exam-register-students.component.css'
})
export class ExamRegisterStudentsComponent {

  allStudents: any[] = [];
  regularData: any[] = [];
  suppleData: any[] = [];
  allSections: string[] = [];

  selectedStudents: any[] = [];
  modalTitle: string = '';
  showModal: boolean = false;

  constructor(private examService: StudentExamsService) { }

  ngOnInit(){
    this.fetchExamRegisteredStudents();
  }

  fetchExamRegisteredStudents(){
    const token = localStorage.getItem('authToken');
    if(!token){
      // this.router.navigate(['/login']);
      return;
    }
    const decodedToken = jwtDecode(token) as {branchId: number};
    const branchId = decodedToken.branchId;

    const br = branchId.toString();
    this.examService.examRegisterStudentsList(br).subscribe({
      next: (resp: any)=>{
        console.log("data is:",resp);
        if (resp) {
           this.allStudents = resp;
           this.processData();
        }
      },
      error: (error)=>{
        console.error("error fetching data",error);
      }
    })
  }

  processData() {
    this.regularData = [];
    this.suppleData = [];

    const sectionSet = new Set<string>();
    this.allStudents.forEach(s => {
      if (s.section) sectionSet.add(s.section);
    });
    this.allSections = Array.from(sectionSet).sort();

    const regularMap = new Map<string, any>();
    const suppleMap = new Map<string, any>();

    this.allStudents.forEach(student => {
      const isRegular = student.examConductTypeName === 'Regular' || student.examConductTypeName?.toLowerCase() === 'regular';
      const isSuccess = student.paymentStatus === 'success' || student.paymentStatus?.toLowerCase() === 'success';
      const sec = student.section;

      const key = `${student.year}-${student.semester}`;
      
      const targetMap = isRegular ? regularMap : suppleMap;
      
      if (!targetMap.has(key)) {
        const successBySection: any = {};
        const failBySection: any = {};
        this.allSections.forEach(s => {
           successBySection[s] = [];
           failBySection[s] = [];
        });

        targetMap.set(key, {
           year: student.year,
           semester: student.semester,
           successList: [],
           failList: [],
           successBySection: successBySection,
           failBySection: failBySection,
           totalList: []
        });
      }

      const group = targetMap.get(key);
      group.totalList.push(student);

      if (isSuccess) {
        group.successList.push(student);
        if (sec && group.successBySection[sec]) {
           group.successBySection[sec].push(student);
        }
      } else {
        group.failList.push(student);
        if (sec && group.failBySection[sec]) {
           group.failBySection[sec].push(student);
        }
      }
    });

    const sortFn = (a: any, b: any) => {
       if (a.year !== b.year) return a.year - b.year;
       return String(a.semester).localeCompare(String(b.semester));
    };

    this.regularData = Array.from(regularMap.values()).sort(sortFn);
    this.suppleData = Array.from(suppleMap.values()).sort(sortFn);
  }

  openModal(title: string, studentsList: any[]) {
    this.modalTitle = title;
    this.selectedStudents = studentsList;
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }
}
